// Golf Hustler LEFT SIDEBAR (golfhustler build only). Black column with the logo
// at top, then the 7 nav destinations (icon + label + sub-label), the active
// route highlighted lime. HUSTLER-guarded via AdminShell so PBCC/GGC never see
// it. Wired to the real GGC routes (functionality unchanged).
import { Link, useLocation } from 'react-router-dom'
import { Home, FolderOpen, Clock, CalendarDays, Users, HelpCircle, Settings } from 'lucide-react'

const ITEMS = [
  { to: '/admin/gg-features', Icon: Home,        label: 'Home',        sub: 'Golf Game Central',
    match: (p) => p === '/admin/gg-features' || p === '/admin/gg' || p === '/admin' },
  { to: '/admin/gg/saved',     Icon: FolderOpen,  label: 'Saved Games', sub: 'View and edit your saved games.' },
  { to: '/admin/gg/history',   Icon: Clock,       label: 'History',     sub: "Every game you've finished, newest first." },
  { to: '/admin/gg/season',    Icon: CalendarDays,label: 'Season',      sub: 'Team Stableford or Team Cup across the season.' },
  { to: '/admin/gg/multigroup',Icon: Users,       label: 'Group Games', sub: 'Handicap & Multi-Group with shared links.' },
  { to: '/admin/gg/help',      Icon: HelpCircle,  label: 'Help',        sub: 'Rules & how-to' },
  { to: '/admin/gg/settings',  Icon: Settings,    label: 'Settings',    sub: 'App preferences' },
]

export default function HustlerSidebar() {
  const { pathname } = useLocation()
  const p = pathname.replace(/\/$/, '')
  return (
    <aside className="hh-sidebar">
      <div className="hh-sidebar-logo">
        <img src="/golfhustler-icon.png" alt="Golf Hustler" />
      </div>
      <nav className="hh-sidebar-nav">
        {ITEMS.map((it) => {
          const active = it.match ? it.match(p) : (p === it.to || p.startsWith(it.to + '/'))
          const Icon = it.Icon
          return (
            <Link key={it.to} to={it.to} className={`hh-nav-item${active ? ' hh-nav-item-active' : ''}`}>
              <Icon size={27} className="hh-nav-icon" strokeWidth={2.2} />
              <span className="hh-nav-text">
                <span className="hh-nav-label">{it.label}</span>
                <span className="hh-nav-sub">{it.sub}</span>
              </span>
            </Link>
          )
        })}
      </nav>
    </aside>
  )
}
